import Pusher from 'pusher-js';

async function loadPublicJsonFallback() {
    const res = await fetch('/pusher-public.json', {
        cache: 'no-store',
    });
    if (!res.ok) {
        return null;
    }
    try {
        const data = await res.json();
        const key = typeof data.key === 'string' ? data.key.trim() : '';
        const cluster = typeof data.cluster === 'string' ? data.cluster.trim() : '';
        if (!key || !cluster) {
            return null;
        }
        return { key, cluster };
    } catch {
        return null;
    }
}

/**
 * Creates the browser Pusher client. Tries in order:
 * 1) REACT_APP_* from the bundle
 * 2) GET /api/pusher/config (Vercel server env: PUSHER_KEY / PUSHER_CLUSTER)
 * 3) GET /pusher-public.json (optional static file — copy from pusher-public.json.example; Pusher key is public by design)
 */
export async function createPusherClient({ userId, username }) {
    let key = process.env.REACT_APP_PUSHER_KEY;
    let cluster = process.env.REACT_APP_PUSHER_CLUSTER;

    if (!key || !cluster) {
        const res = await fetch('/api/pusher/config', {
            credentials: 'same-origin',
        });
        if (res.ok) {
            const data = await res.json();
            key = data.key;
            cluster = data.cluster;
        }
    }

    if (!key || !cluster) {
        const fromFile = await loadPublicJsonFallback();
        if (fromFile) {
            key = fromFile.key;
            cluster = fromFile.cluster;
        }
    }

    if (!key || !cluster) {
        throw new Error(
            'Missing Pusher key/cluster. Fix Vercel env (PUSHER_KEY, PUSHER_CLUSTER) with `vercel env add` or the dashboard, ' +
                'or add public/pusher-public.json (see pusher-public.json.example) and redeploy.',
        );
    }

    const authEndpoint =
        process.env.REACT_APP_PUSHER_AUTH_URL ||
        `${typeof window !== 'undefined' ? window.location.origin : ''}/api/pusher/auth`;

    return new Pusher(key, {
        cluster,
        forceTLS: true,
        authEndpoint,
        authTransport: 'ajax',
        auth: {
            params: {
                user_id: userId,
                username,
            },
        },
    });
}
